export default "__VITE_ASSET__01c45c6a__"